import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import * as styles from './Flyout.scss';

/**
 * Reusable Flyout Component
 * @function Flyout
 * @param {Object} props
 * @return {ReactElement}
 * @example ./Flyout.md
 */
const Flyout = props => {
  const { children, hidden = true, style, className } = props;

  if (hidden) return null;
  return (
    <span className={classNames(styles.flyoutWrapper, className)} style={style}>
      {children}
    </span>
  );
};

Flyout.propTypes = {
  className: PropTypes.string,
  hidden: PropTypes.bool,
  style: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  ),
};

export default Flyout;
